import { useState, useEffect } from 'react'

type CookiePreferences = {
  analytics: boolean
  advertising: boolean
}

const COOKIE_CONSENT_KEY = 'cookie-consent'

export function useCookieConsent() {
  const [showModal, setShowModal] = useState(false)
  const [preferences, setPreferences] = useState<CookiePreferences>(() => {
    const savedConsent = localStorage.getItem(COOKIE_CONSENT_KEY)
    return savedConsent ? JSON.parse(savedConsent) : {
      analytics: false, // Set to false by default to match GA4 'denied' state
      advertising: false // Set to false by default to match GA4 'denied' state
    }
  })

  useEffect(() => {
    const savedConsent = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (!savedConsent) {
      setShowModal(true)
    } else {
      setPreferences(JSON.parse(savedConsent))
    }
  }, [])

  const acceptAll = () => {
    const newPreferences = { analytics: true, advertising: true }
    setPreferences(newPreferences)
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(newPreferences))
    setShowModal(false)
    window.gtag?.('consent', 'update', {
      analytics_storage: 'granted',
      ad_storage: 'granted',
    })
  }

  const savePreferences = (newPreferences: CookiePreferences) => {
    setPreferences(newPreferences)
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(newPreferences))
    setShowModal(false)
    window.gtag?.('consent', 'update', {
      analytics_storage: newPreferences.analytics ? 'granted' : 'denied',
      ad_storage: newPreferences.advertising ? 'granted' : 'denied',
    })
  }

  return {
    showModal,
    preferences,
    acceptAll,
    savePreferences,
    setShowModal,
  }
}